import { Card, CardContent, Tooltip } from "@material-ui/core";
import React, { Component } from "react";
import { TabsStandarSPMI } from "./components/TabsStandarSPMI";
class StandarPerguruanTinggi extends Component {
    
    render(){
        
        return(
            <>
                <TabsStandarSPMI idSp={this.props.id_sp}/>
            </>
        )
    }
}
export default StandarPerguruanTinggi;